import { UserAccess } from './userProperties/level'

export const enum MembersMockMode {
    OFF = '',
    DATA = 'data',
    LOADING = 'loading',
    ERROR = 'error',
    EMPTY = 'empty',
    GUEST = 'guest',
    BASIC = 'basic',
}

const STORAGE_KEY = 'membersMock'

const MODES: Array<string> = [
    MembersMockMode.DATA,
    MembersMockMode.LOADING,
    MembersMockMode.ERROR,
    MembersMockMode.EMPTY,
    MembersMockMode.GUEST,
    MembersMockMode.BASIC,
]

const isMode = (value: string | null | undefined): value is MembersMockMode =>
    !!value && MODES.includes(value)

const cache = { search: null as string | null, mode: MembersMockMode.OFF }

export const getMembersMockMode = (): MembersMockMode => {
    if (
        typeof window === 'undefined' ||
        process.env.NODE_ENV !== 'development'
    ) {
        return MembersMockMode.OFF
    }
    if (cache.search === window.location.search) return cache.mode
    cache.search = window.location.search
    cache.mode = readMembersMockMode()
    return cache.mode
}

const readMembersMockMode = (): MembersMockMode => {
    const fromQuery = new URLSearchParams(window.location.search).get(
        STORAGE_KEY,
    )
    try {
        if (fromQuery === 'off') {
            window.sessionStorage.removeItem(STORAGE_KEY)
            return MembersMockMode.OFF
        }
        if (isMode(fromQuery)) {
            window.sessionStorage.setItem(STORAGE_KEY, fromQuery)
            return fromQuery
        }
        const stored = window.sessionStorage.getItem(STORAGE_KEY)
        if (isMode(stored)) return stored
    } catch {
        if (isMode(fromQuery)) return fromQuery
    }
    const fromEnv = process.env.NEXT_PUBLIC_MEMBERS_MOCK
    return isMode(fromEnv) ? fromEnv : MembersMockMode.OFF
}

export const isMembersMock = () => getMembersMockMode() !== MembersMockMode.OFF

export const isMembersMockGuest = () =>
    getMembersMockMode() === MembersMockMode.GUEST

export const membersMockLevel = (level: UserAccess) => {
    const mode = getMembersMockMode()
    if (mode === MembersMockMode.BASIC) return UserAccess.MEMBER_BASIC
    if (mode !== MembersMockMode.OFF && level < UserAccess.MEMBER_PREMIUM) {
        return UserAccess.MEMBER_PREMIUM
    }
    return level
}
